import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  formControlLabelAlign: {
    // marginLeft: "0px !important",
  },
  fulfillment: {
    marginBottom: "20px !important",
  },
  nameLabelTypo: {
    marginTop: "24px !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    lineHeight: "18px !important",
  },
  userActionContainer: {
    marginTop: "30px !important",
    marginLeft: "34px !important",
  },
  editAddress: {
    float: 'right'
  }
});

export default useStyles;
